/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFindingNativeDetailsForHadolint extends models.SecurityFindingNativeDetailsBaseForContainer {
    constructor() {
        super();
        this.setDiscriminator("SecurityFindingNativeDetailsForHadolint");
    }

    getFixupPrototypeFunction() { return SecurityFindingNativeDetailsForHadolint.fixupPrototype; }

    static newInstance(model: Partial<SecurityFindingNativeDetailsForHadolint>): SecurityFindingNativeDetailsForHadolint {
        let obj = Object.assign(new SecurityFindingNativeDetailsForHadolint(), model);
        SecurityFindingNativeDetailsForHadolint.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFindingNativeDetailsForHadolint>): SecurityFindingNativeDetailsForHadolint {
        if (!model) return null;
        return SecurityFindingNativeDetailsForHadolint.newInstance(<SecurityFindingNativeDetailsForHadolint> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFindingNativeDetailsForHadolint) {
        if (!obj) return;

        models.SecurityFindingNativeDetailsForHadolint.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFindingNativeDetailsForHadolint): boolean {
        if (models.SecurityFindingNativeDetailsBaseForContainer.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SecurityFindingNativeDetailsForHadolint.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.line === undefined) {
            this.line = 0;
        }
        if (this.column === undefined) {
            this.column = 0;
        }
        if (this.source_data) {
            models.SecurityFindingSourceDetailsForHadolint.fixupPrototype(this.source_data);
        }
    }

    /**
     * File path of the Dockerfile that was scanned by Hadolint for best practices and security issues
     */
    file: string;

    /**
     * Line number in the Dockerfile where the security issue was detected
     */
    line: number;

    /**
     * Column position within the line where the security issue begins
     */
    column: number;

    /**
     * Complete original data from Hadolint containing detailed finding information and scan results
     */
    source_data: models.SecurityFindingSourceDetailsForHadolint;

}
